import { useEffect, useState } from "react";
import { fetchPayout } from "../../action/payout";
import { Link } from "react-router-dom";
import { fDateUTC } from "../../utils/helper/timeHelpers";
import Pagination from "../../comman/Pagination";

const Financials = () => {

  const [payouts, setPayouts] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const limit = 10;
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
  const handler = setTimeout(() => {
    setDebouncedSearch(search);
  }, 300);

  return () => clearTimeout(handler);
}, [search]);

 const fetchPayoutListing = async () => {
    try {
      const resp = await fetchPayout({
        page: (page - 1) * limit,
        limit,
        searchQ: debouncedSearch
      });

      if (resp?.data?.payouts) {
        setPayouts(resp.data.payouts);
        setTotal(resp.data.total);
      }
    } catch (error) {
    
    }
  };

  useEffect(() => {
    fetchPayoutListing();
  }, [page, debouncedSearch]);

  const totalPages = Math.ceil(total / limit);

  return (
    <section className="content mb-5">
      <div className="container-fluid">
        <div className="row titlepad">
          <div className="col-md-12">
            <div className="mt-3 mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>

            <div className="row align-items-end">
              <div className="col-sm-9">
                <h4>Financials</h4>
                <p className="page-sub-head">Showing {payouts.length} of {total} results</p>
                {/* <a href="#" className="btn-md btn-primary d-inline-block">
                  <i className="fa-regular fa-file-excel"></i> Export
                </a>
                <a
                  href="#"
                  data-toggle="modal"
                  data-target="#filter"
                  className="btn-md btn-dark d-inline-block"
                >
                  <i className="fa-solid fa-filter"></i> Filter
                </a> */}
              </div>
              <div className="col-md-3">
                <input
                  className="form-control searchinput"
                  type="text"
                  placeholder="Search Financials..."
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="table-responsive bg-white">
              <table
                className="table table-striped table-bordered admintable border-0"
                cellspacing="0"
                cellpadding="0"
              >
                <tbody>
                  <tr>
                    <th>#</th>
                    <th>Order No.</th>
                    <th>Customer Name</th>
                    <th>Service Name</th>
                    <th>Service Amount</th>
                     <th>Created On</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                  {payouts.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center py-3">
                        No results found
                      </td>
                    </tr>
                  ) : (
                    payouts.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.orderNo}</td>
                         <td>
                          <strong>{item.customerName}</strong> <br />
                          {item.customerPhone}
                        </td>
                        <td>{item.serviceName}</td>
                        <td>{item.amount}</td>
                         <td>
                          {fDateUTC(item.createdAt, null, "DD MMM YYYY")}
                        </td>
                        <td>
                          <span className="badge bad-status badge-success">
                            {item.status}
                          </span>
                        </td><td>
                            {/* <a
                              href="#submit-report"
                              className="text-dark f-16 mr-1"
                              data-toggle="modal"
                            >
                              <i className="fa-solid fa-pen-to-square"></i>
                            </a> */}
                            <Link
                              to="/vendor-admin/financialDetails"
                              state={{ payout: item }}
                              className="f-16"
                            >
                              <i className="fa-solid fa-eye"></i>
                            </Link>
                          </td>
                      </tr>
                    ))
                  )}
              </tbody>

              </table>
            </div>
          </div>
            
          <div className="pagination_rounded">
              <div className="mt-4 mb-5 text-center">
                <Pagination
                  page={1}
                  limit={10}
                  total={1}
                  onPageChange={() => {}}
                  showAlways={true}
                />
              </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Financials;
